import TargetingService from '@/api/admin/targeting.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
  },
  getters: {
    allTargetingProperties: state => state.table,
  },
  actions: {
    async getTargetingProperties({ commit }) {
      const targeting = await TargetingService.getTargetingProperties()
      commit('SET_TARGETING_PROPERTIES', targeting)
    },
  },
  mutations: {
    SET_TARGETING_PROPERTIES(state, targeting) {
      state.table.rows = targeting
    },
  },
}
